module.exports = __webpack_public_path__ + "static/img/Graphic-Power-Up.b5a51474.png";